


  
  

  var faArrowsTurnToDots = {
    prefix: 'fast',
    iconName: 'arrows-turn-to-dots',
    icon: [
      512,
      512,
      [],
      'e4c1',
      
      'M274.3 34.3l5.7-5.7L291.3 40l-5.7 5.7L211.3 120 504 120l8 0 0 8 0 120 0 8-16 0 0-8 0-112-284.7 0 74.3 74.3 5.7 5.7L280 227.3l-5.7-5.7-88-88-5.7-5.7 5.7-5.7 88-88zm-36.7 256l88 88 5.7 5.7-5.7 5.7-88 88-5.7 5.7L220.7 472l5.7-5.7L300.7 392 16 392l0 112 0 8L0 512l0-8L0 384l0-8 8 0 292.7 0-74.3-74.3-5.7-5.7L232 284.7l5.7 5.7zM448 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM16 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm112 0A64 64 0 1 1 0 128a64 64 0 1 1 128 0z'
      
    ]
  };

  

  
  

  var faChartMixedUpCircleCurrency = {
    prefix: 'fast',
    iconName: 'chart-mixed-up-circle-currency',
    icon: [
      576,
      512,
      [],
      'e5d8',
      
      'M424 0l-8 0 0 16 8 0 91.9 0L320.3 189 197.7 66.3l-5-5-5.6 4.4-184 144 9.9 12.6L191.4 82.7l123 123 5.3 5.3 5.6-5L528 26.7l0 93.3 0 8 16 0 0-8L544 8l0-8-8 0L424 0zM208 240l0 224-32 0 0-224 32 0zm-32-16l-16 0 0 16 0 224 0 16 16 0 32 0 16 0 0-16 0-224 0-16-16 0-32 0zM80 336l0 128-32 0 0-128 32 0zM48 320l-16 0 0 16 0 128 0 16 16 0 32 0 16 0 0-16 0-128 0-16-16 0-32 0zm256 48a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-200 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm128 0c0-17-5.9-32.6-15.7-44.9l21.4-21.4-11.3-11.3-21.4 21.4C464.6 301.9 449 296 432 296s-32.6 5.9-44.9 15.7l-21.4-21.4-11.3 11.3 21.4 21.4C365.9 335.4 360 351 360 368s5.9 32.6 15.7 44.9l-21.4 21.4 11.3 11.3 21.4-21.4C399.4 434.1 415 440 432 440s32.6-5.9 44.9-15.7l21.4 21.4 11.3-11.3-21.4-21.4C498.1 400.6 504 385 504 368z'
      
    ]
  };

  

  
  

  var faChartNetwork = {
    prefix: 'fast',
    iconName: 'chart-network',
    icon: [
      640,
      512,
      [],
      'f78a',
      
      'M176 16l0 96 96 0 0-96-96 0zM160 0l16 0 96 0 16 0 0 16 0 96 0 6.8 23.1 76c8-1.8 16.3-2.8 24.9-2.8c36.4 0 68.8 17.4 89.2 44.3L512 179.7l0-3.7 0-96 0-16 16 0 96 0 16 0 0 16 0 96 0 16-16 0-96 0-5.6 0L434 249.7c8.9 16.1 14 34.6 14 54.3c0 14.5-2.7 28.3-7.7 41l81.6 39 6.2 0 96 0 16 0 0 16 0 96 0 16-16 0-96 0-16 0 0-16 0-96 0-3-78.7-37.6C414.1 393.2 377.7 416 336 416c-59.2 0-107.6-45.9-111.7-104L128 312l0 40 0 16-16 0-96 0L0 368l0-16 0-96 0-16 16 0 96 0 16 0 0 16 0 40 96.3 0c3.1-44.2 31.9-81.3 71.5-96.6L274.1 128l-2.1 0-96 0-16 0 0-16 0-96 0-16zM112 256l-96 0 0 96 96 0 0-96zM624 80l-96 0 0 96 96 0 0-96zM528 400l0 96 96 0 0-96-96 0zm-192 0a96 96 0 1 0 0-192 96 96 0 1 0 0 192z'
      
    ]
  };

  

  
  

  var faCircleUser = {
    prefix: 'fast',
    iconName: 'circle-user',
    icon: [
      512,
      512,
      [62142,"user-circle"],
      'f2bd',
      
      'M408.5 441.4C461.9 397.3 496 330.7 496 256C496 123.5 388.5 16 256 16S16 123.5 16 256c0 74.7 34.1 141.3 87.5 185.4L144 320l224 0 40.5 121.4zM395 451.7L356.5 336l-200.9 0L117 451.7c39.2 27.9 87.2 44.3 139 44.3s99.8-16.4 139-44.3zm5.3 15.8C359.2 495.6 309.5 512 256 512s-103.2-16.4-144.3-44.5c-4.3-2.9-8.5-6-12.5-9.1c-.3-.3-.7-.5-1-.8C38.4 410.7 0 337.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 81.8-38.4 154.7-98.1 201.6c-4.4 3.4-8.9 6.7-13.4 9.9l-.1 .1zM176 208a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm80 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  
    var faUserCircle = faCircleUser;
  

  
  

  var faCompass = {
    prefix: 'fast',
    iconName: 'compass',
    icon: [
      512,
      512,
      [129517],
      'f14e',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm51.4-204.6L153.3 358.7l51.4-154.1 154.1-51.4L307.4 307.4zm57.7-173L192 192 134.3 365 128 384l19-6.3L320 320l57.7-173 6.3-19-19 6.3zM240 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faEye = {
    prefix: 'fast',
    iconName: 'eye',
    icon: [
      576,
      512,
      [128065],
      'f06e',
      
      'M106.9 384.5C62.9 342 32.6 291.4 17.3 256c15.2-35.4 45.5-86 89.6-128.5C153.5 82.7 214.2 48 288 48s134.5 34.7 181 79.5c44.1 42.5 74.4 93.1 89.6 128.5c-15.2 35.4-45.5 86-89.6 128.5C422.5 429.3 361.8 464 288 464s-134.5-34.7-181.1-79.5zM288 480c158.4 0 258-149.3 288-224C546 181.3 446.4 32 288 32S30 181.3 0 256c30 74.7 129.6 224 288 224zM192 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm208 0a112 112 0 1 0 -224 0 112 112 0 1 0 224 0z'
      
    ]
  };

  

  
  

  var faFlag = {
    prefix: 'fast',
    iconName: 'flag',
    icon: [
      448,
      512,
      [61725,127988],
      'f024',
      
      'M16 8l0-8L0 0 0 8 0 64 0 383.5 0 400 0 504l0 8 16 0 0-8 0-108 112.3-28.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4L448 368l0-334.1L448 16l-16 8L393.6 43.2c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L16 60 16 8zm0 68.5L136.8 46.3c34.4-8.6 70.7-4.6 102.4 11.2c50.8 25.4 110.6 25.4 161.5 0L432 41.9l0 315-45.1 16.9c-42.1 15.8-88.8 13.3-129-6.8c-41.3-20.7-88.7-25.9-133.5-14.7L16 379.5l0-303z'
      
    ]
  };

  

  
  

  var faHeadSideBrain = {
    prefix: 'fast',
    iconName: 'head-side-brain',
    icon: [
      512,
      512,
      [],
      'f808',
      
      'M16 224C16 109.1 109.1 16 224 16l24 0c95.7 0 172.5 77.9 176 172.7l.1 3.4 2.6 2.3L496 256l0 64-56 0-8 0 0 8 0 104-120 0-8 0 0 8 0 64 0 8 16 0 0-8 0-56 120 0 8 0 0-8 0-104 56 0 8 0 0-8 0-75.6 0-3.6-2.7-2.4-69.5-61.8C434.3 83.3 351.6 0 248 0L224 0C100.3 0 0 100.3 0 224c0 59.1 23.7 114.5 64 156.7L64 504l0 8 16 0 0-8 0-126.5 0-3.3-2.3-2.3C38.7 332.1 16 279.7 16 224zM194 113.8c6-10.7 17.2-17.8 30-17.8s24.1 7.1 30 17.8l3.9 6.9 7-3.8c4.3-2.4 9.2-3.7 14.4-3.7c10.6 0 19.9 5.5 25.4 14l2.8 4.3 5.1-.8c1.6-.2 3.3-.4 5-.4c19 0 34.5 15.6 34.5 35.1l0 35.1-88.5 0-8 0 0 8 0 52.3-23.5 0-8 0 0 16 8 0 31.5 0 8 0 0-8 0-52.3 88.5 0 8 0 0-8 0-43.1c0-28.1-22.5-51.1-50.5-51.1c-.8 0-1.6 0-2.3 .1c-8.5-10.5-21.4-17.3-35.9-17.3c-5.4 0-10.5 .9-15.3 2.6c-9.2-12-23.7-19.8-40-19.8s-30.7 7.8-40 19.8c-4.8-1.7-9.9-2.6-15.3-2.6c-21.6 0-39.5 14.9-44.7 34.9c-24.9 3.2-44 24.8-44 50.7c0 19 10.3 35.6 25.5 44.4c.7 27.5 22.9 49.8 50.5 49.8l9 0 0 35.1 0 8 16 0 0-8 0-43.1 0-8-8 0-17 0c-19 0-34.5-15.6-34.5-35.1c0-1 0-1.9 .1-2.9l.5-5.7-5.2-2.3C104.6 209.6 96 197.2 96 182.8c0-19.5 15.5-35.1 34.5-35.1l.2 0 7.2 0 .8-7.2c1.7-15.5 14.6-27.3 30.1-27.3c5.2 0 10.1 1.3 14.4 3.7l7 3.8 3.9-6.9z'
      
    ]
  };

  

  
  

  var faLightbulbOn = {
    prefix: 'fast',
    iconName: 'lightbulb-on',
    icon: [
      640,
      512,
      [],
      'f672',
      
      'M480 176c0 33.9-10.5 65.3-28.5 91.2c-4.5 6.5-9.5 13.3-14.5 20.2c-12.5 17.2-25.9 35.5-36.3 54.4c-7.4 13.5-11.6 27.8-14 42.2l16.2 0c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5l16.2 0c-2.4-14.4-6.6-28.7-14-42.2c-10.4-19-23.7-37.3-36.3-54.4c0 0 0 0 0 0s0 0 0 0c-5-6.9-10-13.7-14.5-20.2c-18-25.9-28.5-57.3-28.5-91.2c0-88.4 71.6-160 160-160s160 71.6 160 160zm-256-8c0-48.6 39.4-88 88-88l0-16c-57.4 0-104 46.6-104 104l16 0zm32 328l0-64 128 0 0 64-128 0zm-16-80l0 16 0 64 0 16 16 0 128 0 16 0 0-16 0-64 0-16-16 0-128 0-16 0zM49.1 4.1L42.3 0 34 13.7l6.9 4.1 75 45 6.9 4.1L131 53.3l-6.9-4.1-75-45zm550 13.7l6.9-4.1L597.7 0l-6.9 4.1-75 45L509 53.3 517.3 67l6.9-4.1 75-45zM8 160l-8 0 0 16 8 0 80 0 8 0 0-16-8 0L8 160zm544 0l-8 0 0 16 8 0 80 0 8 0 0-16-8 0-80 0zM124.1 270.9l6.9-4.1L122.7 253l-6.9 4.1-75 45L34 306.3 42.3 320l6.9-4.1 75-45zm400-13.7l-6.9-4.1L509 266.7l6.9 4.1 75 45 6.9 4.1 8.2-13.7-6.9-4.1-75-45z'
      
    ]
  };

  

  
  

  var faSolarSystem = {
    prefix: 'fast',
    iconName: 'solar-system',
    icon: [
      512,
      512,
      [],
      'e02f',
      
      'M273.9 495.3c31.7-2.4 61.5-10.8 88.3-24.1c2.6 4.6 5.7 9.1 9.3 13.2c-29.2 14.8-61.8 24.2-96.5 26.8C134.1 521.9 11.3 416.1 .7 275.1c-4.5-60.1 12.1-116.9 43.6-163.1C36.6 103.6 32 92.3 32 80c0-26.5 21.5-48 48-48c12.3 0 23.5 4.6 32 12.3c0 0 0 0 0 0c.6 .5 1.2 1.1 1.8 1.7C122.6 54.6 128 66.7 128 80c0 26.5-21.5 48-48 48c-8.4 0-16.3-2.2-23.2-5.9c-29.1 43.1-44.4 96-40.2 151.9c9.9 132.2 125.1 231.3 257.3 221.4zM140.4 27.5C169.6 12.7 202.2 3.3 236.9 .7c141-10.6 263.9 95.2 274.4 236.1c4.5 60.1-12.1 116.9-43.6 163.1c7.6 8.5 12.3 19.7 12.3 32.1c0 26.5-21.5 48-48 48c-12.3 0-23.5-4.6-32-12.3c0 0 0 0 0 0c-.6-.6-1.3-1.2-1.9-1.8c-3.3-3.3-6-6.9-8.1-10.8c0 0 0 0 0 0c-3.8-6.9-6-14.8-6-23.2c0-26.5 21.5-48 48-48c8.4 0 16.3 2.2 23.2 5.9c29.1-43.1 44.4-96 40.2-151.9C485.4 105.9 370.2 6.8 238.1 16.7c-31.7 2.4-61.5 10.8-88.3 24.1c-2.6-4.6-5.7-9.1-9.3-13.2zM112 256c0 79.5 64.5 144 144 144s144-64.5 144-144c0-22.7-5.3-44.2-14.6-63.3c-7.4 4.6-16.1 7.3-25.4 7.3c-26.5 0-48-21.5-48-48c0-9.3 2.7-18 7.3-25.4C300.2 117.3 278.7 112 256 112c-79.5 0-144 64.5-144 144zm304 0c0 88.4-71.6 160-160 160s-160-71.6-160-160s71.6-160 160-160c26.8 0 52.1 6.6 74.3 18.3c8.2-6.4 18.5-10.3 29.7-10.3c26.5 0 48 21.5 48 48c0 11.2-3.8 21.5-10.3 29.7C409.4 203.9 416 229.2 416 256zM80 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm312 40a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm40 312a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 336l-11.3-11.3-57.4-57.4L176 256l11.3-11.3 57.4-57.4L256 176l11.3 11.3 57.4 57.4L336 256l-11.3 11.3-57.4 57.4L256 336zm0-137.4L198.6 256 256 313.4 313.4 256 256 198.6z'
      
    ]
  };

  

  
  

  var faStarShooting = {
    prefix: 'fast',
    iconName: 'star-shooting',
    icon: [
      512,
      512,
      [127776],
      'e036',
      
      'M309.7 21.7l-72 72L232 99.3 220.7 88l5.7-5.7 72-72L304 4.7 315.3 16l-5.7 5.7zm192 0l-168 168-5.7 5.7L316.7 184l5.7-5.7 168-168L496 4.7 507.3 16l-5.7 5.7zm0 192l-72 72-5.7 5.7L412.7 280l5.7-5.7 72-72 5.7-5.7L507.3 208l-5.7 5.7zM202.4 162.1l50.9 103.1L367 281.7l19.9 2.9-14.4 14.1-82.3 80.2 19.4 113.3L313 512l-17.8-9.4L193.5 449.1 91.7 502.6 73.9 512l3.4-19.9L96.7 378.9 14.4 298.6 0 284.6l19.9-2.9 113.7-16.5 50.9-103.1 8.9-18.1 8.9 18.1zM251 281l-8.3-1.2-3.7-7.5-45.4-92.1L148 272.2l-3.7 7.5L136 281 34.4 295.7l73.5 71.7 6 5.9-1.4 8.3L95.1 482.8 186 435l7.4-3.9 7.4 3.9 90.9 47.8L274.4 381.6l-1.4-8.3 6-5.9 73.5-71.7L251 281z'
      
    ]
  };

  

  
  

  var faUsersRays = {
    prefix: 'fast',
    iconName: 'users-rays',
    icon: [
      640,
      512,
      [],
      'e593',
      
      'M21.7 10.3l72 72L99.3 88 88 99.3l-5.7-5.7-72-72L4.7 16 16 4.7l5.7 5.7zm608 11.3l-72 72L552 99.3 540.7 88l5.7-5.7 72-72L624 4.7 635.3 16l-5.7 5.7zm-536 408l-72 72L16 507.3 4.7 496l5.7-5.7 72-72 5.7-5.7L99.3 424l-5.7 5.7zm464-11.3l72 72 5.7 5.7L624 507.3l-5.7-5.7-72-72-5.7-5.7L552 412.7l5.7 5.7zM176 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm192 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM214.2 368l211.6 0-21.3-64-168.9 0-21.3 64zm9.8-80l192 0 26.7 80 5.3 16-16.9 0-222.3 0L192 384l5.3-16L224 288zM432 176a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm80 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM132.2 272l-15.3 56 60 0-5.3 16-59 0L96 344l4.4-16L120 256l80.9 0-5.3 16-63.4 0zm330.8 56l60 0-15.3-56-63.4 0-5.3-16 80.9 0 19.6 72 4.4 16-16.6 0-59 0-5.3-16z'
      
    ]
  };

  



export {

  faArrowsTurnToDots,
  

  faChartMixedUpCircleCurrency,
  

  faChartNetwork,
  

  faCircleUser,
  
  faUserCircle,
  

  faCompass,
  

  faEye,
  

  faFlag,
  

  faHeadSideBrain,
  

  faLightbulbOn,
  

  faSolarSystem,
  

  faStarShooting,
  

  faUsersRays,
  

};
